/**
 * Email Signup Block Component
 *
 * Handles dynamic padding adjustment for email signup input fields
 * when integrated buttons have variable widths.
 */
class EmailSignupBlock extends HTMLElement {
  constructor() {
    super();
    /** @type {number} */
    this.lastButtonWidth = 0;
    /** @type {ResizeObserver | undefined} */
    this.observer = undefined;

    this.adjustInputPadding = this.adjustInputPadding.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector('.email-signup__button--integrated');
    this.input = this.querySelector('.email-signup__input');
    this.inputGroup = this.querySelector('.email-signup__input-group');

    const isTextButton = this.button && this.button.classList.contains('email-signup__button--text');

    if (this.button && this.input && this.inputGroup && isTextButton) {
      this.adjustInputPadding();

      this.observer = new ResizeObserver(() => {
        this.adjustInputPadding();
      });
      this.observer.observe(this.button);

      if ('fonts' in document) {
        document.fonts.ready.then(() => {
          this.adjustInputPadding();
        });
      }
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  adjustInputPadding() {
    if (!this.button || !this.inputGroup) return;

    const buttonWidth = /** @type {HTMLElement} */ (this.button).offsetWidth;

    if (buttonWidth !== this.lastButtonWidth) {
      this.lastButtonWidth = buttonWidth;
      /** @type {HTMLElement} */ (this.inputGroup).style.setProperty('--button-actual-width', `${buttonWidth}px`);
    }
  }
}

if (!customElements.get('email-signup-block')) {
  customElements.define('email-signup-block', EmailSignupBlock);
}

/* DYFM: mirror password-page signups to Brevo, then continue normal Shopify submit */
(function () {
  var BREVO_URL = 'https://4bde466f.sibforms.com/serve/MUIFAAQbsIWzAqsySypYjtXNymQqENU5RnoaVPSDbXLRew-bdrcoXf0S_VKLmr7otGg-0JCRNDoXdyl3901IdC11pClTzz7RXUZTKRJltIqGeWS_QrZ8GckcvxKwYFzqeIomjXpwcv4IgozM-KUXE7IAMUa8MpYjsitBIIWLbKFWAq_0Tqgu8jRkmhLA5Jeycz3xUUNYxrmocp9g';
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('dyfm-newsletter__form')) return;
    if (form.dataset.brevoSent === '1') return;
    var input = form.querySelector('input[type="email"], input[name="contact[email]"]');
    var email = input ? String(input.value || '').trim() : '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || typeof fetch !== 'function') return;
    e.preventDefault();
    form.dataset.brevoSent = '1';
    var done = false;
    var go = function () { if (done) return; done = true; HTMLFormElement.prototype.submit.call(form); };
    try {
      var body = new URLSearchParams({ EMAIL: email, email_address_check: '', locale: 'de', html_type: 'simple' });
      fetch(BREVO_URL, { method: 'POST', mode: 'no-cors', keepalive: true, body: body }).then(go, go);
    } catch (err) { go(); }
    setTimeout(go, 800);
  });
})();
